export function dataIsoLocal(data: Date) {
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const dia = String(data.getDate()).padStart(2, '0');
  return `${data.getFullYear()}-${mes}-${dia}`;
}

export function filtroListagemDocumentosPadrao(hoje = new Date()) {
  const iso = dataIsoLocal(hoje);
  return {
    dataInicial: iso,
    dataFinal: iso,
    pagina: 1,
    limite: 50
  };
}

export function ajustarPeriodoListagem(dataInicial: string, dataFinal: string) {
  if (dataFinal && dataInicial && dataFinal < dataInicial) {
    return { dataInicial: dataFinal, dataFinal: dataInicial };
  }
  return { dataInicial, dataFinal };
}
